var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "FlyerlineModal",
    {
      ref: "modal",
      attrs: { name: "addressBookAddAddress" },
      on: { close: _vm.handleClose },
    },
    [
      _c("SkyFormLoader", {
        attrs: {
          formName: "shop_addaddress",
          params: { shop_addressKeyType: 2 },
        },
        on: { success: _vm.handleConfirm },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }